import axios from './httpConfig.js'
//******************出入库管理 -- 出库 ******************/
// 出库SN列表
export function GetSNList(param) {
	return axios.post('/admin/issue/sn/list', param)
}
// 出库单 列表
export function GetOrderList(param) {
	return axios.post('/admin/issue/order/list', param)
}

// 新增SN出库
export function AddSN(param) {
	return axios.post('/admin/issue/sn/add', param)
}

// 删除已出库SN
export function DeleteSN(param) {
	return axios.post('/admin/issue/sn/delete', param)
}

// 删除已出库 整个订单
export function DeleteOrder(param) {
	return axios.post('/admin/issue/order/delete', param)
}

// 删除已出库 订单中的货品
export function DeleteGoods(param) {
	return axios.post('/admin/issue/order/goods/delete', param)
}

// 单据的全部信息
export function GetOrderInfo(param) {
	return axios.post('/admin/issue/order/info', param)
}

// 修改已出库SN
export function EditSN(param) {
	return axios.post('/admin/issue/sn/edit', param)
}

// 修改已出库单据主信息
export function EditMainInfo(param) {
	return axios.post('/admin/issue/order/info/edit', param)
}

// 修改已出库货位
export function EditGoodsLocation(param) {
	return axios.post('/admin/issue/order/goods/edit', param)
}

// 导出出库列表
export function ExportSNList(param) {
	return axios.postBlob('/admin/issue/sn/export', param)
}
// 导出出库订单列表
export function ExportOrderList(param) {
	return axios.postBlob('/admin/issue/order/export', param)
}

// 根据入库单号分类的入库单_列表
export function GetOrderNumberList(param) {
	return axios.post('/admin/issue/userdiy/order/list', param)
}

// 读取_根据自定义入库单号分类的入库单_信息
export function GetOrderNumberInfo(param) {
	return axios.post('/admin/issue/userdiy/order/info', param)
}

export const sockOutRequest = {
	GetSNList,
	GetOrderList,
	AddSN,
	DeleteSN,
	DeleteOrder,
	DeleteGoods,
	GetOrderInfo,
	EditSN,
	EditMainInfo,
	EditGoodsLocation,
	ExportSNList,
	ExportOrderList,
	GetOrderNumberList,
	GetOrderNumberInfo
}